import type { IntlShape } from 'react-intl'
import type {
	PurchaseInvoiceFormInput,
	PurchaseInvoiceRowFormInput,
} from './types'

export const formHeaders: PurchaseInvoiceFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Toimittaja',
				description: 'Table column header: supplier',
			}),
		key: 'suppCname',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskun nro.',
				description: 'Table column header: Invoice number',
			}),
		key: 'invoiceNum',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Päivämäärä',
				description: 'Table column header: Date',
			}),
		key: 'date',
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viitenumero',
				description: 'Table column header: Reference number',
			}),
		key: 'referenceNumber',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tosite',
				description: 'Table column header: Voucher',
			}),
		key: 'voucher.number',
		show: true,
		type: 'readonly',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Maksuehto',
				description: 'Table column header: Payment term',
			}),
		key: 'paymTerm',
		show: true,
		type: 'number',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'RF-viite',
				description: 'Table column header: RF reference',
			}),
		key: 'referenceNote',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Eräpäivä',
				description: 'Table column header: Due date',
			}),
		key: 'dueDate',
		show: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tilinumero',
				description: 'Table column header: Account number',
			}),
		key: 'accountNumber',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskun summa',
				description: 'Table column header: Total',
			}),
		key: 'total',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'IBAN',
				description: 'Table column header: IBAN',
			}),
		key: 'iban',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Valuutta',
				description: 'Table column header: Currency',
			}),
		key: 'currency',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'BIC',
				description: 'Table column header: BIC',
			}),
		key: 'bic',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Lisätietoja',
				description: 'Table column header: Additional info',
			}),
		key: 'info',
		show: true,
		type: 'string',
	},
]

export const rowTableHeaders: PurchaseInvoiceRowFormInput[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tili',
				description: 'Account',
			}),
		key: 'account', //TODO:
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tilin nimi',
				description: 'Account name',
			}),
		key: 'accountName',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Yhteensä',
				description: 'Total',
			}),
		key: 'total',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Kustannuspaikka',
				description: 'Cost center',
			}),
		key: 'costCentreId',
		show: true,
		type: 'string',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'ALV',
				description: 'VAT',
			}),
		key: 'vat',
		show: true,
		type: 'string',
	},
]
